import { TableHeadItemRecurse } from '../../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Emissor', flex: 1.5 },
  { title: 'Nome', flex: 3 },
  { title: 'Bloqueios', flex: 1.5 },
  { title: 'Controle', flex: 1.5 },
];
